import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { CourseModel } from 'src/app/model/course';

@Component({
  selector: 'app-teacher-course-card',
  templateUrl: './teacher-course-card.component.html',
  styleUrls: ['./teacher-course-card.component.css']
})
export class TeacherCourseCardComponent implements OnInit {
  @Input() courseData : CourseModel | any;
  @Input() dataType: any;
  @Input() classType:any;
  @Output() actionOnClick= new EventEmitter<any>();

  public isOnGoing: boolean = false;
  public isCompleted: boolean = false;
  public isUpcomming: boolean = false;
  public isStartTomrrow: boolean = false;
  public waitingDays: number = 0;

  public cronjob: any = null;

  constructor(
    private _eventHandlingService: EventHandlingService
  ) { }

  ngOnInit(): void {
    this.checkStatus()
    // console.log("courseData: ", this.courseData)
  }

  checkStatus = () => {
    this.isOnGoing = UtilityService.isOnGoing(this.courseData?.schedule);
    this.isUpcomming = UtilityService.isUpcomming(this.courseData?.schedule?.startDate, this.courseData?.schedule?.serverTime);
    this.isStartTomrrow = UtilityService.isTomorrow(this.courseData?.schedule?.startDate, this.courseData?.schedule?.serverTime);
    this.waitingDays = UtilityService.getWaitingDays(this.courseData?.schedule?.startDate, this.courseData?.schedule?.serverTime);
  }

  getClassStatusText():any{
    if(this.isOnGoing) {
      return 'Ongoing'
    } else if(this.isStartTomrrow) {
      return 'Starts tomorrow'
    } else if(this.isUpcomming) {
      return 'Starts in ' + this.waitingDays + ' days';
    }
  }

}
